/**
 * Back To Top interaction.
 *
 * Note that we are not using anchor #hash because we want to preserve the #hash for permalink.
 */
export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  return async () => {
    $('#back-to-top').on('click', ev => {
      ev.preventDefault();

      // if preloader exists, scroll to header, otherwise scroll to very top
      const elPreloader = $('#page').siblings('.preloader');
      if (elPreloader.length) {
        $('html, body').scrollTop(window.innerHeight);
      }
      else {
        $('html, body').scrollTop(0);
      }
    });
  };
})(jQuery, window);